import React, { useEffect, useRef, useState } from "react";
import calendericon from "../../../assets/patientcharts/calendericon.svg";
import { Grid, Typography } from "@mui/material";

import dayjs from "dayjs";
import DateRangeSelector from "../../../daterangepicker/DateRangeSelector";

const HeaderCalender = ({
    setSelectedDateRange,
    selectedDateRange,
  handleView,
  view,
  selectedTab = "",
  setSearchDate,
  handleFilterChange,
  searchDate,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isfilteropen, setIsfilteropen] = useState(false);
  const calendarRef = useRef(null);



  // ✅ Formatters
  const formatDate = (dateString) => dayjs(dateString).format("YYYY-MM-DD");
  const formatDatetommddyyyy = (dateString) => dayjs(dateString).format("MM-DD-YYYY");

  // ✅ Apply selected range
  const handleApply = () => {
    setSearchDate({
      startDate: formatDate(selectedDateRange.startDate),
      endDate: formatDate(selectedDateRange.endDate),
    });
    setIsCalendarOpen(false);
  };

  // ✅ Reset
const handleReset = () => {
  const resetRange = {
    startDate: null,
    endDate: null,
    key: "selection",
  };

  setSelectedDateRange(resetRange);
  setSearchDate({
    startDate: "",
    endDate: "",
  });
};

  // ✅ Handle outside click to close calendar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

   const BiList = () => {
        return (
            <div className="relative w-[33px] h-[33px] cursor-pointer" onClick={()=>handleView(1)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15625 24.75C5.15625 24.4765 5.2649 24.2142 5.4583 24.0208C5.65169 23.8274 5.914 23.7188 6.1875 23.7188H26.8125C27.086 23.7188 27.3483 23.8274 27.5417 24.0208C27.7351 24.2142 27.8438 24.4765 27.8438 24.75C27.8438 25.0235 27.7351 25.2858 27.5417 25.4792C27.3483 25.6726 27.086 25.7812 26.8125 25.7812H6.1875C5.914 25.7812 5.65169 25.6726 5.4583 25.4792C5.2649 25.2858 5.15625 25.0235 5.15625 24.75ZM5.15625 16.5C5.15625 16.2265 5.2649 15.9642 5.4583 15.7708C5.65169 15.5774 5.914 15.4688 6.1875 15.4688H26.8125C27.086 15.4688 27.3483 15.5774 27.5417 15.7708C27.7351 15.9642 27.8438 16.2265 27.8438 16.5C27.8438 16.7735 27.7351 17.0358 27.5417 17.2292C27.3483 17.4226 27.086 17.5312 26.8125 17.5312H6.1875C5.914 17.5312 5.65169 17.4226 5.4583 17.2292C5.2649 17.0358 5.15625 16.7735 5.15625 16.5ZM5.15625 8.25C5.15625 7.9765 5.2649 7.71419 5.4583 7.5208C5.65169 7.3274 5.914 7.21875 6.1875 7.21875H26.8125C27.086 7.21875 27.3483 7.3274 27.5417 7.5208C27.7351 7.71419 27.8438 7.9765 27.8438 8.25C27.8438 8.5235 27.7351 8.78581 27.5417 8.9792C27.3483 9.1726 27.086 9.28125 26.8125 9.28125H6.1875C5.914 9.28125 5.65169 9.1726 5.4583 8.9792C5.2649 8.78581 5.15625 8.5235 5.15625 8.25Z" 
      fill={!view?"#1D2951":"#E17954"}/>
    </svg>
            </div>
        );
    };
    const MaterialSymbols = () => {
        return (
            <div className="relative w-[33px] h-[33px] color-[#E17954] cursor-pointer" onClick={()=>handleView(0)}>
             <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
      <path d="M12.2169 14.4375H7.72062C7.08812 14.4375 6.56012 14.2257 6.13662 13.8022C5.71312 13.3788 5.50092 12.8503 5.5 12.2169V7.72062C5.5 7.08812 5.71221 6.56012 6.13662 6.13662C6.56104 5.71312 7.0895 5.50092 7.722 5.5H12.2169C12.8494 5.5 13.3778 5.71221 13.8022 6.13662C14.2267 6.56104 14.4384 7.0895 14.4375 7.722V12.2169C14.4375 12.8494 14.2257 13.3778 13.8022 13.8022C13.3788 14.2267 12.8503 14.4384 12.2169 14.4375ZM7.72062 13.0625H12.2169C12.4635 13.0625 12.666 12.9832 12.8246 12.8246C12.9832 12.666 13.0625 12.4635 13.0625 12.2169V7.72062C13.0625 7.47404 12.9832 7.27146 12.8246 7.11287C12.666 6.95429 12.4635 6.875 12.2169 6.875H7.72062C7.47404 6.875 7.27146 6.95429 7.11287 7.11287C6.95429 7.27146 6.875 7.4745 6.875 7.722V12.2169C6.875 12.4635 6.95429 12.666 7.11287 12.8246C7.27146 12.9832 7.4745 13.0625 7.722 13.0625M12.2169 27.5H7.72062C7.08812 27.5 6.56012 27.2882 6.13662 26.8647C5.71312 26.4412 5.50092 25.9123 5.5 25.278V20.7845C5.5 20.1511 5.71221 19.6226 6.13662 19.1991C6.56104 18.7756 7.0895 18.5634 7.722 18.5625H12.2169C12.8494 18.5625 13.3778 18.7747 13.8022 19.1991C14.2267 19.6235 14.4384 20.152 14.4375 20.7845V25.2794C14.4375 25.9119 14.2257 26.4403 13.8022 26.8647C13.3788 27.2892 12.8503 27.5009 12.2169 27.5ZM7.72062 26.125H12.2169C12.4635 26.125 12.666 26.0457 12.8246 25.8871C12.9832 25.7285 13.0625 25.526 13.0625 25.2794V20.7831C13.0625 20.5365 12.9832 20.334 12.8246 20.1754C12.666 20.0168 12.4635 19.9375 12.2169 19.9375H7.72062C7.47404 19.9375 7.27146 20.0168 7.11287 20.1754C6.95429 20.334 6.875 20.537 6.875 20.7845V25.2794C6.875 25.526 6.95429 25.7285 7.11287 25.8871C7.27146 26.0457 7.4745 26.125 7.722 26.125M25.2794 14.4375H20.7831C20.1506 14.4375 19.6226 14.2257 19.1991 13.8022C18.7756 13.3788 18.5634 12.8503 18.5625 12.2169V7.72062C18.5625 7.08812 18.7747 6.56012 19.1991 6.13662C19.6235 5.71312 20.152 5.50092 20.7845 5.5H25.2794C25.9119 5.5 26.4403 5.71221 26.8647 6.13662C27.2892 6.56104 27.5009 7.0895 27.5 7.722V12.2169C27.5 12.8494 27.2882 13.3778 26.8647 13.8022C26.4412 14.2267 25.9137 14.4384 25.2794 14.4375ZM20.7831 13.0625H25.2794C25.526 13.0625 25.7285 12.9832 25.8871 12.8246C26.0457 12.666 26.125 12.4635 26.125 12.2169V7.72062C26.125 7.47404 26.0457 7.27146 25.8871 7.11287C25.7285 6.95429 25.526 6.875 25.2794 6.875H20.7831C20.5365 6.875 20.334 6.95429 20.1754 7.11287C20.0168 7.27146 19.9375 7.4745 19.9375 7.722V12.2169C19.9375 12.4635 20.0168 12.666 20.1754 12.8246C20.334 12.9832 20.537 13.0625 20.7845 13.0625M25.2794 27.5H20.7831C20.1506 27.5 19.6226 27.2882 19.1991 26.8647C18.7756 26.4412 18.5634 25.9123 18.5625 25.278V20.7845C18.5625 20.1511 18.7747 19.6226 19.1991 19.1991C19.6235 18.7756 20.152 18.5634 20.7845 18.5625H25.2794C25.9119 18.5625 26.4403 18.7747 26.8647 19.1991C27.2892 19.6235 27.5009 20.152 27.5 20.7845V25.2794C27.5 25.9119 27.2882 26.4403 26.8647 26.8647C26.4412 27.2892 25.9137 27.5009 25.2794 27.5ZM20.7831 26.125H25.2794C25.526 26.125 25.7285 26.0457 25.8871 25.8871C26.0457 25.7285 26.125 25.526 26.125 25.2794V20.7831C26.125 20.5365 26.0457 20.334 25.8871 20.1754C25.7285 20.0168 25.526 19.9375 25.2794 19.9375H20.7831C20.5365 19.9375 20.334 20.0168 20.1754 20.1754C20.0168 20.334 19.9375 20.537 19.9375 20.7845V25.2794C19.9375 25.526 20.0168 25.7285 20.1754 25.8871C20.334 26.0457 20.537 26.125 20.7845 26.125" 
      fill={view?"#1D2951":"#E17954"}/>
    </svg>
            </div>
        );
    };

  return (
    <Grid item>
      <Grid container alignItems="center" justifyContent="flex-end" spacing={1} wrap="nowrap">
        <Grid item>
          <BiList />
        </Grid>
        <Grid item>
          <MaterialSymbols />
        </Grid>

        {/* Calendar Display */}
        <Grid item>
          <div
            style={{ boxShadow: "0 1px 8px rgba(0, 0, 0, 0.1)" }}
            className="w-[150px] md:w-[200px] shadow relative h-8 md:h-10 bg-white rounded-[16px] md:rounded-[19px] flex items-center justify-between px-3 md:px-4"
          >
            <span className="font-normal text-xs md:text-sm text-[#1d2951]">
              <div className="text-xs" >
             {
  selectedDateRange?.startDate && selectedDateRange?.endDate
    ? `${formatDatetommddyyyy(selectedDateRange.startDate)} → ${formatDatetommddyyyy(
        selectedDateRange.endDate
      )}`
    : "Select Date"
}
              </div>
            </span>
            <img
              onClick={() => setIsCalendarOpen(!isCalendarOpen)}
              className="w-5 md:w-6 h-5 md:h-6 cursor-pointer"
              alt="Calendar Icon"
              src={calendericon}
            />
          </div>
        </Grid>

        {/* Calendar Popup */}
        {isCalendarOpen && (
          <div
            ref={calendarRef}
            className="fixed lg:top-[200px] top-[23%] lg:right-[90px] z-10  rounded-md p-2"
          >
            <DateRangeSelector
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              onSubmit={handleApply}
              handlereset={handleReset}
            />
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default HeaderCalender;
